import { useWithdrawContext, DashboardTransfersWithdrawBalanceName } from '@ppay/client'

export const ConfirmModalToBalance = ({ balanceName }: { balanceName: string }) => {
  const { ticker } = useWithdrawContext()
  return <DashboardTransfersWithdrawBalanceName ticker={ticker} value={balanceName} />
}
